import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'app-discount-type-select',
    // exportAs: 'ngModel', disabled until finding out how to replace #project="ngModel" attribute of <app-project-select> to render validation errors via <span *ngIf="project.invalid && (project.dirty || project.touched)">
    templateUrl: './discount-type-select.component.html',
    styleUrls: ['./discount-type-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DiscountTypeSelectComponent),
            multi: true
        }
    ]
})
export class DiscountTypeSelectComponent implements ControlValueAccessor {
    @Input() disabled = false;

    options = [
        { value: 0, label: 'Acquisto' },
        { value: 1, label: 'Vendita' },
    ];

    value: number;

    private onChange: (val: number) => void = () => {};
    private onTouched: () => void = () => {};

    onChanged(event: number) {
        this.value = event;
        this.onChange(event);
        this.onTouched();
    }

    writeValue(val: number): void { this.value = val; }
    registerOnChange(fn: any): void { this.onChange = fn; }
    registerOnTouched(fn: any): void { this.onTouched = fn; }
    setDisabledState(isDisabled: boolean): void { this.disabled = isDisabled; }
}